export const ADMIN_MONITORING_TRANSLATION_NAMESPACE = "admin-monitoring";

export const ADMIN_MONITORING_TK = "ADMIN_MONITORING_TK";
export const SIDE_MENU_TK = "SIDE_MENU_TK";
